module.exports = __webpack_public_path__ + "static/ilustracion-landing-02-65e0cd03e8798c7921ee6d6a8428f24b.svg";